import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import "./Management6.css";
import { FaTrash, FaSave, FaEdit } from "react-icons/fa";
const FoodInventory = () => {
    const [data, setData] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [editItem, setEditItem] = useState(null);

    // Fetch inventory data
    useEffect(() => {
        const fetchInventory = async () => {
            const vendorId = localStorage.getItem("vendorId");
            const authToken = localStorage.getItem("authToken");
            if (!vendorId || !authToken) return;

            try {
                const res = await axios.get(
                    `https://backend.maamaas.com/food/api/inventory/get-item/${vendorId}`,
                    { headers: { Authorization: `Bearer ${authToken}` } }
                );
                const formatted = res.data.map((item, idx) => ({
                    itemId: item.id,
                    SNo: idx + 1,
                    item: item.itemName || "",
                    quantity: item.quantity || 0,
                    consumed: item.consumed || 0,
                    balance: item.balance || 0,
                    procurementValue: item.procurementValue || 0,
                }));
                setData(formatted);
            } catch (err) {
                console.error(err);
            }
        };
        fetchInventory();
    }, []);

    // Add new row (first-time entry)
    const handleAddRow = () => {
        setData((prev) => [
            ...prev,
            {
                SNo: prev.length + 1,
                item: "",
                quantity: "",
                consumed: 0,
                balance: 0,
                procurementValue: 0,
                itemId: null,
            },
        ]);
    };

    // Save first-time entry
    const handleSave = async (index) => {
        const authToken = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        const item = data[index];

        if (!item.item || !item.quantity) {
            alert("Item name and quantity are required.");
            return;
        }

        const payload = {
            itemName: item.item,
            quantity: parseFloat(item.quantity) || 0,
            consumed: parseFloat(item.consumed) || 0,
            balance: parseFloat(item.quantity) - parseFloat(item.consumed),
            procurementValue: parseFloat(item.procurementValue) || 0,
            date: new Date().toISOString().split("T")[0],
            vendorId: parseInt(vendorId),
        };

        try {
            const res = await axios.post(
                `https://backend.maamaas.com/food/api/inventory/add/${vendorId}`,
                payload,
                { headers: { Authorization: `Bearer ${authToken}` } }
            );

            alert("Item added successfully!");
            const updated = [...data];
            updated[index].itemId = res.data.id;
            updated[index].balance = payload.balance;
            setData(updated);
        } catch (err) {
            console.error(err);
            alert("Failed to save item.");
        }
    };

    // Open popup for editing existing data
    const handleEdit = (item) => {
        setEditItem({ ...item }); // copy item for editing
        setPopupOpen(true);
    };

    // Save updates from popup
    const handleUpdate = async () => {
        if (!editItem.item || !editItem.quantity) {
            alert("Item name and quantity are required.");
            return;
        }

        const authToken = localStorage.getItem("authToken");

        const payload = {
            itemName: editItem.item,
            quantity: parseFloat(editItem.quantity) || 0,
            balance: (parseFloat(editItem.quantity) || 0) - (parseFloat(editItem.consumed) || 0),
        };

        try {
            await axios.put(
                `https://backend.maamaas.com/food/api/inventory/update/${editItem.itemId}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            // Update local state
            const updatedData = data.map((d) =>
                d.itemId === editItem.itemId
                    ? { ...d, item: payload.itemName, quantity: payload.quantity, balance: payload.balance }
                    : d
            );
            setData(updatedData);
            setPopupOpen(false);
            alert("Item updated successfully!");
        } catch (err) {
            console.error(err);
            alert("Failed to update item.");
        }
    };

    // Delete row
    const handleDelete = async (itemId) => {
        if (!itemId) return;
        const authToken = localStorage.getItem("authToken");
        try {
            await axios.delete(
                `https://backend.maamaas.com/food/api/inventory/delete/${itemId}`,
                { headers: { Authorization: `Bearer ${authToken}` } }
            );
            setData(data.filter((d) => d.itemId !== itemId));
            alert("Item deleted successfully!");
        } catch (err) {
            console.error(err);
            alert("Failed to delete item.");
        }
    };

    return (
        <div className="invetory-data">
            <button onClick={handleAddRow} style={addButtonStyle}>Add+</button>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr style={{ backgroundColor: "#b15cd6", color: "#fff" }}>
                        <th style={tableCellStyle}>S.No</th>
                        <th style={tableCellStyle}>Item</th>
                        <th style={tableCellStyle}>Quantity</th>
                        <th style={tableCellStyle}>Consumed</th>
                        <th style={tableCellStyle}>Balance</th>
                        <th style={tableCellStyle}>Procurement</th>
                        <th style={tableCellStyle}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, idx) => (
                        <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#fff" : "#f2f2f2" }}>
                            <td style={tableCellStyle}>{item.SNo}</td>
                            <td style={tableCellStyle}>
                                <input
                                    type="text"
                                    value={item.item}
                                    onChange={(e) => {
                                        const updated = [...data];
                                        updated[idx].item = e.target.value;
                                        setData(updated);
                                    }}
                                    disabled={!!item.itemId} // disable if already saved
                                    style={inputStyle}
                                />
                            </td>
                            <td style={tableCellStyle}>
                                <input
                                    type="number"
                                    value={item.quantity}
                                    onChange={(e) => {
                                        const updated = [...data];
                                        updated[idx].quantity = e.target.value;
                                        updated[idx].balance = (parseFloat(e.target.value) || 0) - (parseFloat(updated[idx].consumed) || 0);
                                        setData(updated);
                                    }}
                                    disabled={!!item.itemId}
                                    style={inputStyle}
                                />
                            </td>
                            <td style={tableCellStyle}>{item.consumed}</td>
                            <td style={tableCellStyle}>{item.balance}</td>
                            <td style={tableCellStyle}>
                                <input
                                    type="number"
                                    value={item.procurementValue}
                                    onChange={(e) => {
                                        const updated = [...data];
                                        updated[idx].procurementValue = e.target.value;
                                        setData(updated);
                                    }}
                                    disabled={!!item.itemId}
                                    style={inputStyle}
                                />
                            </td>
                            <td style={tableCellStyle}>
                                {!item.itemId ? (
                                    <button onClick={() => handleSave(idx)} style={saveButtonStyle}>Save</button>
                                ) : (
                                    <>
                                        <button onClick={() => handleEdit(item)} style={{ ...editButtonStyle, backgroundColor: "green" }}>    <FaEdit /></button>
                                        <button onClick={() => handleDelete(item.itemId)} style={deleteButtonStyle}> <FaTrash /></button>
                                    </>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Popup modal for editing */}
            {popupOpen && (
                <div style={popupStyle}>
                    <div style={popupContentStyle}>
                        <h3>Edit Item</h3>
                        <label>Item Name:</label>
                        <input
                            type="text"
                            value={editItem.item}
                            onChange={(e) =>
                                setEditItem({ ...editItem, item: e.target.value })
                            }
                            style={inputStyle}
                        />

                        <label>Quantity:</label>
                        <input
                            type="number"
                            value={editItem.quantity}
                            onChange={(e) =>
                                setEditItem({
                                    ...editItem,
                                    quantity: e.target.value,
                                    balance: (parseFloat(e.target.value) || 0) - (parseFloat(editItem.consumed) || 0),
                                })
                            }
                            style={inputStyle}
                        />

                        <div style={{ marginTop: "10px" }}>
                            <button onClick={handleUpdate} style={saveButtonStyle}>
                                Update
                            </button>
                            <button onClick={() => setPopupOpen(false)} style={deleteButtonStyle}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
const tableHeaderStyle = { padding: "12px", border: "1px solid #ddd", textAlign: "center", fontWeight: "bold", backgroundColor: "#b15cd6", color: "white" };
const tableCellStyle = { padding: "12px", border: "1px solid #ddd", textAlign: "center" };
const evenRowStyle = {};
const oddRowStyle = { backgroundColor: "#fff" };
const inputStyle = { width: "100%", border: "none", textAlign: "center", backgroundColor: "transparent" };
const addButtonStyle = { padding: "8px 16px", backgroundColor: "#b15cd6", color: "white", border: "none", cursor: "pointer", borderRadius: "5px", width: "100px" };
const editButtonStyle = { color: "white", border: "none", padding: "5px 10px", cursor: "pointer", borderRadius: "5px", marginRight: "5px" };
const deleteButtonStyle = { backgroundColor: "red", color: "white", border: "none", padding: "5px 10px", cursor: "pointer", borderRadius: "5px" };
const popupOverlayStyle = { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 };
const popupContentStyle = { backgroundColor: "#fff", borderRadius: "12px", padding: "30px", width: "400px", boxShadow: "0 4px 12px rgba(0,0,0,0.2)", fontFamily: "Arial, sans-serif" };
const popupInputStyle = { width: "100%", padding: "10px", marginBottom: "12px", borderRadius: "6px", border: "1px solid #ccc", fontSize: "14px" };
const saveButtonStyle = { backgroundColor: "#4CAF50", color: "white", padding: "10px 20px", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: "bold" };


const popupStyle = { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center" };

export default FoodInventory;
